import { PlayerLogDescription } from '../enums/playerLogDescription'
import type { JsonHttpRequestOptions } from '../interfaces/JsonHttpRequestOptions'
import Http from '../utils/http'

interface SessionPlayerLogParams extends Record<
    string,
    string | number | boolean | null | undefined
> {
    proxmox_streaming_token: string
    description: PlayerLogDescription
    os_name: string
    browser_name: string
    browser_version: string
    is_mobile_browser: boolean
    is_vd_agent_connected: boolean
    is_cursor_in_captured_mode: boolean
    local_candidate?: string | null
    remote_candidate?: string | null
    error_id?: number | null
    last_frontend_report?: string | null
}

interface VdAgentPlayerLogParams extends Record<
    string,
    string | number | boolean | null | undefined
> {
    proxmox_streaming_token: string
    description: PlayerLogDescription
}

const sendSessionLog = (
    params: SessionPlayerLogParams,
    options: JsonHttpRequestOptions = { displayToastOnError: false }
): void => {
    Http.postJson(`/api/player-logs/session`, params, options).catch(
        (error) => {
            if (document.visibilityState === 'hidden') {
                return
            }

            console.error(
                `Network error while sending ${params.description} log:`,
                error
            )
        }
    )
}

const sendVdAgentLog = (
    params: VdAgentPlayerLogParams,
    options: JsonHttpRequestOptions = { displayToastOnError: false }
): void => {
    Http.postJson(`/api/player-logs/vd-agent`, params, options).catch(
        (error) => {
            if (document.visibilityState === 'hidden') {
                return
            }

            console.error(
                `Network error while sending ${params.description} log:`,
                error
            )
        }
    )
}

export default { sendSessionLog, sendVdAgentLog }
